import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { joinFamily, joinFamilyAsHouseholdMember, joinFamilyAsMergeTarget } from '@coparent/shared/src/services/familyService';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { HiUserGroup } from 'react-icons/hi';
import toast from 'react-hot-toast';

const JoinFamily = () => {
  const { currentUser, refreshUserData } = useAuth();
  const navigate = useNavigate();
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleJoin = async (e) => {
    e.preventDefault();
    if (!inviteCode.trim()) {
      toast.error('Please enter an invite code');
      return;
    }
    setLoading(true);
    try {
      // Check invite type to determine join flow
      const inviteDocSnap = await getDoc(doc(db, 'invites', inviteCode.toUpperCase()));
      const invite = inviteDocSnap.exists() ? inviteDocSnap.data() : null;

      if (invite?.type === 'household') {
        await joinFamilyAsHouseholdMember(
          currentUser.uid,
          currentUser.displayName,
          inviteCode,
          invite.householdOf
        );
        await refreshUserData();
        toast.success('Joined as a household member!');
      } else if (invite?.type === 'merge') {
        await joinFamilyAsMergeTarget(currentUser.uid, currentUser.displayName, inviteCode);
        await refreshUserData();
        toast.success('Account linked successfully!');
      } else {
        const result = await joinFamily(currentUser.uid, currentUser.displayName, inviteCode);
        await refreshUserData();
        if (result.joinedAs === 'household_member') {
          toast.success('The co-parent role is already filled \u2014 you\'ve been added as a household member.');
        } else {
          toast.success('Joined family successfully!');
        }
      }
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.message || 'Failed to join family');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50 px-4">
      <div className="max-w-sm w-full animate-slide-up">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 bg-parent2-100 rounded-2xl flex items-center justify-center mb-5 shadow-warm">
            <HiUserGroup className="text-2xl text-parent2-600" />
          </div>
          <h2 className="text-2xl font-bold text-ink-900 tracking-tight">Join a Family</h2>
          <p className="mt-1.5 text-ink-400 text-sm">Enter the invite code your co-parent shared with you.</p>
        </div>

        <div className="card p-7">
          <form onSubmit={handleJoin}>
            <label className="block text-xs font-semibold text-ink-600 mb-1.5 uppercase tracking-wide">Invite Code</label>
            <input
              value={inviteCode}
              onChange={e => setInviteCode(e.target.value.toUpperCase())}
              type="text"
              maxLength={6}
              className="input-base text-center text-2xl font-mono font-bold tracking-[0.2em] uppercase !py-3"
              placeholder="ABC123"
            />
            <button
              type="submit"
              disabled={loading}
              className="btn-accent w-full mt-6"
            >
              {loading ? 'Joining...' : 'Join Family'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JoinFamily;
